import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import EmailConfirmation from './EmailConfirmation';
import AuthHeader from '../AuthHeader';
import Footer from '../Footer';

import supabase from '../../services/supabaseClient';

function EmailConfirmationPage() {
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState(null);
  const { confirmationHash } = useParams();

  useEffect(() => {
    let isMounted = true;

    const confirmEmail = async () => {
      if (!confirmationHash) {
        setError('This confirmation link is invalid. Please use the link from your email.');
        return;
      }

      // The token in the link can be a signup token or a generic email token
      for (const type of ['signup', 'email']) {
        const { error: verifyError } = await supabase.auth.verifyOtp({
          token_hash: confirmationHash,
          type,
        });
        if (!isMounted) return;
        if (!verifyError) {
          setConfirmed(true);
          return;
        }
      }

      // The token may already have been consumed (e.g. the email client
      // prefetched the link); if a session exists the address is confirmed.
      const { data: { session } } = await supabase.auth.getSession();
      if (!isMounted) return;

      if (session) {
        setConfirmed(true);
      } else {
        setError('This confirmation link is invalid or has expired. Please sign up again or request a new link.');
      }
    };

    confirmEmail();

    return () => {
      isMounted = false;
    };
  }, [confirmationHash]);

  return (
    <div className="auth-page-container">
      <div className="auth-content">
        <div className="container">
          <AuthHeader />
          <div className="auth-form-container">
            <EmailConfirmation confirmed={confirmed} error={error} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EmailConfirmationPage;
